module.exports = __webpack_public_path__ + "static/add-ea1d1e3bd339882aa3e3b78dbd2b694b.png";